import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { SectionValidation } from 'src/app/core/managers/service-validation.manager';

export interface CargoValidationModalData {
    cargo: Cargo;
    sections: { [key: string]: SectionValidation };
}

@Component({
    selector: 'app-cargo-validation-modal',
    templateUrl: './cargo-validation-modal.component.html',
    styleUrls: ['./cargo-validation-modal.component.scss']
})
export class CargoValidationModalComponent {
    public sectionsArray: { key: string, section: SectionValidation }[] = [];
    constructor(
        public dialogRef: MatDialogRef<CargoValidationModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CargoValidationModalData
    ) {
        this.sectionsArray = Object.keys(this.data.sections).map(key => ({
            key,
            section: this.data.sections[key]
        }));
    }

    canEditSection(section: SectionValidation): boolean {
        return section.canEdit.every(restriction => restriction.restriction);
    }

    get sectionsWithErrors(): string {
        const sectionsWithErrors = this.sectionsArray.filter(item => !item.section.checkValid.isValid);
        if (!sectionsWithErrors.length) return '';
        if (sectionsWithErrors.length === 1) return `Se encontraron errores en la sección de ${sectionsWithErrors[0].section.name.toLowerCase()}`;
        return `Se encontraron errores en ${sectionsWithErrors.length} secciones`;
    }

    onEditSection(sectionKey: string): void {
        this.dialogRef.close(sectionKey);
    }

    getRestrictionFailed(section: SectionValidation): string {
        const restrictionFailed = section.canEdit.find(restriction => !restriction.restriction);
        if (restrictionFailed) return restrictionFailed.message;
        return '';
    }

    onClose(): void {
        this.dialogRef.close();
    }
}
